import { type FC } from "react";
import { useTranslation } from "react-i18next";
import { Filter, useFilter } from "@/partner/shared/components/Filter";
import {
  CONTRACT_PAYMENT_STATUSES,
  contractPaymentStatusKey,
} from "../model/paymentStatus";
import { DownloadReportButton } from "@/partner/features/reports";
import { ReportTypeType } from "@/types/graphql/partner.generated";
import { buildInvoicesFilter } from "../model/buildInvoicesFilter";

// У раздела нет отдельных ключей `billing.filter.*` в сиде (в отличие от
// payments/chargebacks), поэтому заголовок карточки и подпись селекта берут
// уже существующие тексты страницы и колонки, а не выдуманные.
export const BillingInvoicesFilter: FC = () => {
  const { t } = useTranslation();
  const { filter } = useFilter();

  return (
    <Filter
      title={t("billing.pageTitle")}
      action={
        <DownloadReportButton
          type={ReportTypeType.ContractPaymentsType}
          filter={
            buildInvoicesFilter(filter) as Record<string, unknown> | undefined
          }
        />
      }
      selects={[
        {
          name: "status",
          label: t("billing.invoices.columns.status"),
          options: CONTRACT_PAYMENT_STATUSES.map((value) => ({
            value,
            label: t(`billing.status.${contractPaymentStatusKey(value)}`),
          })),
        },
      ]}
      fields={{ dateFrom: true, dateTo: true }}
    />
  );
};
